import configure from 'redux-idle-monitor';

//Importo actions
import {
    idleStatusDelay,
    activeStatusAction,
    idleStatusAction
} from '../actions/TimerInactividad';

//Importo constantes
import { IDLE_STATUSES } from '../actions/TimerInactividad';

//Eventos que activan
const activeEvents = [
    //'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mouseWheel',
    'mousedown',
    'touchstart',
    //'touchmove',
    'MSPointerDown',
    //'MSPointerMove'
];

const options = {
    appName: 'App',
    IDLE_STATUSES,
    idleStatusDelay,
    activeStatusAction,
    idleStatusAction,
    activeEvents
};

const { middleware, reducer, actions } = configure(options);
export { middleware, reducer, actions };


// WEBPACK FOOTER //
// ./Portico/App/Screens/TimerInactividad/components/TimerInactividad.js